module.exports = __webpack_public_path__ + "static/gradient1-0ce05478a5e4daf29fea709c6abfae21.png";